export function parseJwt(token) {
  console.log("token enter", token);
  if (!token || typeof token !== "string") return null;

  try {
    const parts = token.split(".");
    console.log("parts", parts);
    if (parts.length !== 3) return null;
    console.log("parts.length", parts);

    const decodePart = (str) => {
      const base64Url = str;
      const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
      const jsonPayload = decodeURIComponent(
        atob(base64)
          .split("")
          .map((c) => "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2))
          .join(""),
      );
      return JSON.parse(jsonPayload);
    };
    console.log("decodePart", decodePart(parts[0]));
    console.log("decodePart", decodePart(parts[1]));
    console.log("decodePart", parts[2]);
    return {
      header: decodePart(parts[0]),
      payload: decodePart(parts[1]),
      signature: parts[2],
    };
  } catch (error) {
    console.error("Error parsing JWT:", error);
    return null;
  }
}
